// Utils
import { isErrorUnauthorized, isNetworkError, ErrorResponse } from "@/utils/http";
import { showNetworkConnectionToast } from "@/services/toast";
import logout from "@/utils/logout.ts";
import { AppWithI18n } from "@/types/appWithI18n.ts";

export default function getHttpErrorHandler(
  Vue: AppWithI18n
): (_error: ErrorResponse) => Promise<never> {
  return (error: ErrorResponse) => {
    if (isNetworkError(error)) {
      showNetworkConnectionToast(Vue);
    } else if (isErrorUnauthorized(error) && !error.config?.disabledAuthorizationError) {
      logout();
    }
    return Promise.reject(error);
  };
}
